
import
  {
    WDCardList,
    WDApi,
    WDFormat
  } from 'wd';

import LookupCard from './lookup-card';

/**
  Events:
  kiosks:selected -> when an kiosk is picked, it passes the kiosk back to the caller
  */

export default class GLLookupCard extends LookupCard
{
  constructor()
  {
    super({ title: 'GL Accounts' });
  };

  get fetchURI()
  {
    return `/lookup/companies/${this.company.value}/glaccounts`;
  }

  get fetchApi()
  {
    return new WDApi(this.fetchURI, {
      show_defaults: '0',
    });
  }

  get listConfig()
  {
    return {
      columns: [
        { label: 'GL Account', value: 'label' }
      ],
      valueField: 'id',
      focusable: true,
      method: 'post',
      options: [],
      click: (item, row) => {},    //ensures the list responds to clicks
      filters: [
        { type: 'text', name: 'search_string', placeholder: 'Search GL Accounts', static: true },
      ],
      buttons: [
        {
          fasIcon: 'file-invoice-dollar',
          title: 'View Transactions',
          click: (data) => this.viewTransactions(data),
        }
      ]
    };

  };

  viewTransactions(data) 
  {
    const tc = this.cardList.querySelector('transactions-card');
    tc.glAccount = data;
    this.cardList.showCard('wd-card-transactions');
  };

  handleSelected(evt)
  {
    this.triggerHammer(evt,evt.detail.model.gl_account_number_formatted);
  };


};


customElements.define('gl-lookup-card', GLLookupCard);

